/* Ritaglio a onda della scheda prodotto: rettangolo arrotondato con l'incavo in basso a destra,
   raccordi concavi sui due bordi e angolo convesso dentro l'incavo. Il pulsante nero sta nell'incavo. */
(function () {
  var BASE = { R: 20, f: 28, nw: 110, nh: 68, r2: 18, gap: 7 };

  function ritaglia(sc, W, H) {
    if (!sc) return;
    var inn = sc.querySelector('.gs-sc__in');
    if (!inn) return;
    if (W === undefined) { W = inn.offsetWidth; H = inn.offsetHeight; }
    if (!W || !H) return;
    if (sc._gsW === W && sc._gsH === H) return;
    sc._gsW = W; sc._gsH = H;

    var k = W < 200 ? 0.64 : (W < 240 ? 0.8 : 1);
    var R = BASE.R, f = Math.round(BASE.f * k), nw = Math.round(BASE.nw * k),
        nh = Math.round(BASE.nh * k), r2 = Math.round(BASE.r2 * k), gap = Math.round(BASE.gap * k);

    sc.classList.toggle('gs-sc--mini', k < 1);
    sc.classList.toggle('gs-sc--tel', k < 0.7);
    sc.style.setProperty('--gs-nw', nw + 'px');
    sc.style.setProperty('--gs-nh', nh + 'px');
    sc.style.setProperty('--gs-r2', r2 + 'px');
    sc.style.setProperty('--gs-gap', gap + 'px');

    var d = 'M' + R + ',0 H' + (W - R) + ' A' + R + ',' + R + ' 0 0 1 ' + W + ',' + R +
      ' V' + (H - nh - f) + ' Q' + W + ',' + (H - nh) + ' ' + (W - f) + ',' + (H - nh) +
      ' H' + (W - nw + r2) + ' A' + r2 + ',' + r2 + ' 0 0 0 ' + (W - nw) + ',' + (H - nh + r2) +
      ' V' + (H - f) + ' Q' + (W - nw) + ',' + H + ' ' + (W - nw - f) + ',' + H +
      ' H' + R + ' A' + R + ',' + R + ' 0 0 1 0,' + (H - R) + ' V' + R + ' A' + R + ',' + R + ' 0 0 1 ' + R + ',0 Z';
    var cp = 'path("' + d + '")';
    inn.style.clipPath = cp;
    inn.style.webkitClipPath = cp;
  }

  /* le misure arrivano dal ResizeObserver (subito dopo il layout, prima del disegno):
     niente letture forzate una scheda alla volta */
  function misureDa(v) {
    var b = v.borderBoxSize && v.borderBoxSize[0];
    if (b) return [Math.round(b.inlineSize), Math.round(b.blockSize)];
    return [v.target.offsetWidth, v.target.offsetHeight];
  }
  var ro = window.ResizeObserver
    ? new ResizeObserver(function (voci) {
        for (var i = 0; i < voci.length; i++) { var m = misureDa(voci[i]); ritaglia(voci[i].target.closest('.gs-sc'), m[0], m[1]); }
      })
    : null;

  function avvia(root) {
    var schede = (root || document).querySelectorAll('.gs-sc:not([data-gs-pronta])');
    for (var i = 0; i < schede.length; i++) {
      var sc = schede[i];
      sc.setAttribute('data-gs-pronta', '');
      var inn = sc.querySelector('.gs-sc__in');
      if (ro && inn) ro.observe(inn); else ritaglia(sc);
    }
  }

  function tutte() {
    var schede = document.querySelectorAll('.gs-sc');
    for (var i = 0; i < schede.length; i++) { schede[i]._gsW = 0; ritaglia(schede[i]); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { avvia(); });
  } else {
    avvia();
  }
  document.addEventListener('shopify:section:load', function () { avvia(); });
  document.addEventListener('shopify:block:select', tutte);

  /* animazione del carrello in testata: al click pulsa, quando l'articolo entra rimbalza */
  function carrello() {
    return document.querySelector('cart-icon.header-actions__cart-icon') || document.querySelector('cart-icon');
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('add-to-cart-component button');
    if (!b || b.disabled) return;
    var c = carrello();
    if (!c) return;
    c.classList.remove('gs-aggiunta');
    c.classList.add('gs-carico');
    clearTimeout(c._gsCarico);
    c._gsCarico = setTimeout(function () { c.classList.remove('gs-carico'); }, 5000);
  }, true);
  document.addEventListener('cart:update', function (e) {
    var d = (e.detail && e.detail.data) || {};
    var c = carrello();
    if (!c) return;
    if (d.didError) { c.classList.remove('gs-carico'); return; }
    if (d.source !== 'product-form-component') return;
    clearTimeout(c._gsCarico);
    c.classList.remove('gs-carico');
    c.classList.remove('gs-aggiunta');
    void c.offsetWidth;
    c.classList.add('gs-aggiunta');
    var vecchio = c.querySelector('.gs-piu');
    if (vecchio) vecchio.remove();
    var p = document.createElement('span');
    p.className = 'gs-piu';
    p.setAttribute('aria-hidden', 'true');
    p.textContent = '+1';
    c.appendChild(p);
    setTimeout(function () { c.classList.remove('gs-aggiunta'); p.remove(); }, 1000);
  });

  /* --- card recensioni: stesso incavo a onda, con dentro il pulsante "scrivi una recensione" --- */
  function larghezzaPulsanti(root) {
    // stesso incavo su tutte le card: stessa misura di pulsante e stessi raccordi
    var griglie = (root || document).querySelectorAll('.gs-rec__griglia');
    for (var g = 0; g < griglie.length; g++) {
      var carte = griglie[g].querySelectorAll('.gs-rec__card');
      var minW = Infinity, k;
      for (k = 0; k < carte.length; k++) {
        var q = carte[k].querySelector('.gs-rec__in');
        if (q && q.offsetWidth) minW = Math.min(minW, q.offsetWidth);
      }
      var piccola = minW < 300, media = minW < 560;
      griglie[g].style.setProperty('--gs-rec-gap', (piccola ? 5 : media ? 6 : 7) + 'px');
      griglie[g].style.setProperty('--gs-rec-r2', (piccola ? 11 : media ? 14 : 16) + 'px');
      griglie[g].style.setProperty('--gs-rec-f', (piccola ? 16 : media ? 20 : 26) + 'px');
      var btns = griglie[g].querySelectorAll('.gs-rec__btn');
      var max = 0, i;
      for (i = 0; i < btns.length; i++) { btns[i].style.width = 'auto'; }
      for (i = 0; i < btns.length; i++) { max = Math.max(max, Math.ceil(btns[i].getBoundingClientRect().width)); }
      for (i = 0; i < btns.length; i++) { if (max) btns[i].style.width = max + 'px'; }
    }
  }

  function classiRec(root) {
    var carte = (root || document).querySelectorAll('.gs-rec__card');
    for (var i = 0; i < carte.length; i++) {
      var inn = carte[i].querySelector('.gs-rec__in');
      if (!inn) continue;
      var W = inn.offsetWidth;
      if (!W) continue;
      carte[i].classList.toggle('gs-rec--compatta', W < 560);
      carte[i].classList.toggle('gs-rec--mini', W < 300);
    }
  }

  function ritagliaRec(sc) {
    if (!sc) return;
    var inn = sc.querySelector('.gs-rec__in');
    var btn = sc.querySelector('.gs-rec__btn');
    if (!inn) return;
    var W = inn.offsetWidth, H = inn.offsetHeight;
    if (!W || !H) return;
    var R = parseFloat(getComputedStyle(inn).borderTopLeftRadius) || 22;
    if (!btn) {
      inn.style.clipPath = '';
      inn.style.webkitClipPath = '';
      sc.style.setProperty('--gs-rec-nw', '0px');
      return;
    }
    var st = getComputedStyle(sc);
    var gap = parseFloat(st.getPropertyValue('--gs-rec-gap')) || 7;
    var r2 = parseFloat(st.getPropertyValue('--gs-rec-r2')) || 16;
    var f = parseFloat(st.getPropertyValue('--gs-rec-f')) || 26;
    var bw = Math.ceil(btn.getBoundingClientRect().width);
    var bh = Math.ceil(btn.getBoundingClientRect().height);
    var nw = Math.min(bw + gap * 2, Math.max(60, W - 2 * f - 10));
    var nh = bh + gap * 2;
    sc.style.setProperty('--gs-rec-nw', nw + 'px');
    sc.style.setProperty('--gs-rec-nh', nh + 'px');

    var d = 'M' + R + ',0 H' + (W - R) + ' A' + R + ',' + R + ' 0 0 1 ' + W + ',' + R +
      ' V' + (H - nh - f) + ' Q' + W + ',' + (H - nh) + ' ' + (W - f) + ',' + (H - nh) +
      ' H' + (W - nw + r2) + ' A' + r2 + ',' + r2 + ' 0 0 0 ' + (W - nw) + ',' + (H - nh + r2) +
      ' V' + (H - f) + ' Q' + (W - nw) + ',' + H + ' ' + (W - nw - f) + ',' + H +
      ' H' + R + ' A' + R + ',' + R + ' 0 0 1 0,' + (H - R) + ' V' + R + ' A' + R + ',' + R + ' 0 0 1 ' + R + ',0 Z';
    var cp = 'path("' + d + '")';
    inn.style.clipPath = cp;
    inn.style.webkitClipPath = cp;
  }

  var roRec = window.ResizeObserver
    ? new ResizeObserver(function (voci) {
        voci.forEach(function (v) { ritagliaRec(v.target.closest('.gs-rec__card')); });
      })
    : null;

  function avviaRec(root) {
    var carte = (root || document).querySelectorAll('.gs-rec__card:not([data-gs-pronta])');
    for (var i = 0; i < carte.length; i++) {
      var sc = carte[i];
      sc.setAttribute('data-gs-pronta', '');
      var inn = sc.querySelector('.gs-rec__in');
      if (roRec && inn) roRec.observe(inn);
    }
    if (carte.length) tutteRec();
  }
  function tutteRec() {
    classiRec();
    larghezzaPulsanti();
    var carte = document.querySelectorAll('.gs-rec__card');
    for (var i = 0; i < carte.length; i++) ritagliaRec(carte[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { avviaRec(); });
  } else {
    avviaRec();
  }
  window.addEventListener('load', tutteRec);
  window.addEventListener('resize', function () { clearTimeout(window.__gsRecT); window.__gsRecT = setTimeout(tutteRec, 120); });
  document.addEventListener('shopify:section:load', function () { avviaRec(); tutteRec(); });
  if (document.fonts && document.fonts.ready) { document.fonts.ready.then(tutteRec); }

  /* --- incavo a onda generico: qualunque card con data-gs-onda --- */
  function ritagliaOnda(sc) {
    if (!sc) return;
    var inn = sc.querySelector('[data-gs-in]');
    var btn = sc.querySelector('[data-gs-btn]');
    if (!inn || !btn) return;
    var W = inn.offsetWidth, H = inn.offsetHeight;
    if (!W || !H) return;
    var R = parseFloat(getComputedStyle(inn).borderTopLeftRadius) || 20;
    var stretta = W < 300;
    var gap = stretta ? 5 : 7;
    var r2 = stretta ? 12 : (parseFloat(sc.getAttribute('data-gs-r2')) || 17);
    var f = stretta ? 16 : (parseFloat(sc.getAttribute('data-gs-f')) || 24);
    var bw = Math.ceil(btn.getBoundingClientRect().width);
    var bh = Math.ceil(btn.getBoundingClientRect().height);
    var nw = Math.min(bw + gap * 2, Math.max(60, W - 2 * f - 10));
    var nh = bh + gap * 2;
    sc.style.setProperty('--gs-nw', nw + 'px');
    sc.style.setProperty('--gs-nh', nh + 'px');
    sc.style.setProperty('--gs-gap', gap + 'px');
    sc.style.setProperty('--gs-r2', r2 + 'px');
    var d = 'M' + R + ',0 H' + (W - R) + ' A' + R + ',' + R + ' 0 0 1 ' + W + ',' + R +
      ' V' + (H - nh - f) + ' Q' + W + ',' + (H - nh) + ' ' + (W - f) + ',' + (H - nh) +
      ' H' + (W - nw + r2) + ' A' + r2 + ',' + r2 + ' 0 0 0 ' + (W - nw) + ',' + (H - nh + r2) +
      ' V' + (H - f) + ' Q' + (W - nw) + ',' + H + ' ' + (W - nw - f) + ',' + H +
      ' H' + R + ' A' + R + ',' + R + ' 0 0 1 0,' + (H - R) + ' V' + R + ' A' + R + ',' + R + ' 0 0 1 ' + R + ',0 Z';
    var cp = 'path("' + d + '")';
    inn.style.clipPath = cp;
    inn.style.webkitClipPath = cp;
  }

  var roOnda = window.ResizeObserver
    ? new ResizeObserver(function (voci) {
        voci.forEach(function (v) { ritagliaOnda(v.target.closest('[data-gs-onda]')); });
      })
    : null;

  function avviaOnda(root) {
    var carte = (root || document).querySelectorAll('[data-gs-onda]:not([data-gs-ok])');
    for (var i = 0; i < carte.length; i++) {
      carte[i].setAttribute('data-gs-ok', '');
      var inn = carte[i].querySelector('[data-gs-in]');
      if (roOnda && inn) roOnda.observe(inn); else ritagliaOnda(carte[i]);
    }
  }
  function tutteOnda() {
    var carte = document.querySelectorAll('[data-gs-onda]');
    for (var i = 0; i < carte.length; i++) ritagliaOnda(carte[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { avviaOnda(); });
  } else {
    avviaOnda();
  }
  window.addEventListener('resize', function () { clearTimeout(window.__gsOndaT); window.__gsOndaT = setTimeout(tutteOnda, 120); });
  document.addEventListener('shopify:section:load', function () { avviaOnda(); tutteOnda(); });
  if (document.fonts && document.fonts.ready) { document.fonts.ready.then(tutteOnda); }

  /* --- pop-up: data-gs-apri apre, data-gs-chiudi e il velo chiudono --- */
  function popApri(id){
    var p=document.getElementById(id);
    var v=document.querySelector('[data-gs-velo="'+id+'"]');
    if(!p) return;
    p.hidden=false; if(v) v.hidden=false;
    document.documentElement.style.overflow='hidden';
    var x=p.querySelector('[data-gs-chiudi]'); if(x) x.focus();
  }
  function popChiudi(){
    var aperti=document.querySelectorAll('.gs-pop:not([hidden]), .gs-pop__velo:not([hidden])');
    for(var i=0;i<aperti.length;i++) aperti[i].hidden=true;
    document.documentElement.style.overflow='';
  }
  document.addEventListener('click', function(e){
    var a=e.target.closest && e.target.closest('[data-gs-apri]');
    if(a){ e.preventDefault(); popApri(a.getAttribute('data-gs-apri')); return; }
    if(e.target.closest && (e.target.closest('[data-gs-chiudi]') || e.target.matches('.gs-pop__velo'))) popChiudi();
  });
  document.addEventListener('keydown', function(e){ if(e.key==='Escape') popChiudi(); });

  /* ---- La barra di ricerca dell intestazione apre il pop-up ---- */
  function apriRicerca(e){
    if (window.matchMedia && !window.matchMedia('(min-width: 750px)').matches) return;
    var bottone = document.querySelector('.search-modal__button');
    if (!bottone) return;
    e.preventDefault();
    if (e.target && e.target.blur) e.target.blur();
    bottone.click();
    setTimeout(function(){
      var campo = document.querySelector('#search-modal input[type="search"], .search-modal input[type="search"]');
      if (campo) campo.focus();
    }, 120);
  }
  document.addEventListener('mousedown', function(e){
    var barra = e.target.closest && e.target.closest('.search-action--inline-bar');
    if (barra) apriRicerca(e);
  });
  document.addEventListener('focusin', function(e){
    if (e.target.classList && e.target.classList.contains('search-action__inline-input')) apriRicerca(e);
  });
  document.addEventListener('submit', function(e){
    if (e.target.classList && e.target.classList.contains('search-action--inline-bar')) {
      var campo = e.target.querySelector('.search-action__inline-input');
      if (!campo || !campo.value.trim()) { e.preventDefault(); apriRicerca(e); }
    }
  });

  /* ---- Luci di pietra: piccoli bagliori sparsi su canvas ----
     Decorative, quindi non devono mai pesare sulla pagina:
     - da telefono (o con "riduci movimento") sono solo disegnate, ferme: nessuna animazione continua;
     - da desktop un solo controller anima a 24 fotogrammi le sole tele visibili, si ferma con la scheda
       in background e, se un fotogramma supera la soglia, passa a luci ferme per tutta la sessione.
     Bagliori e stelle sono disegnati una volta in uno stampo e poi copiati. */
  var LUCI_RIF = 10, LUCI_SCALA = 2, stampi = {};
  var LUCI_TEL = window.matchMedia && window.matchMedia('(max-width: 749px), (pointer: coarse)').matches;
  var LUCI_RIDOTTO = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var LUCI_SESSIONE = false;
  try { LUCI_SESSIONE = sessionStorage.getItem('gsLuciFerme') === '1'; } catch (e) {}
  var LUCI_FERMO = LUCI_TEL || LUCI_RIDOTTO || LUCI_SESSIONE;
  var LUCI_PASSO = 41, LUCI_SOGLIA = 16, LUCI_RISCALDO = 3;
  function stampoBagliore(col){
    if (stampi[col]) return stampi[col];
    var raggio = LUCI_RIF * 3 * LUCI_SCALA, c = document.createElement('canvas');
    c.width = c.height = Math.ceil(raggio * 2);
    var x = c.getContext('2d'), g = x.createRadialGradient(raggio, raggio, 0, raggio, raggio, raggio);
    g.addColorStop(0, col + '1)'); g.addColorStop(.35, col + '.35)'); g.addColorStop(1, col + '0)');
    x.fillStyle = g; x.beginPath(); x.arc(raggio, raggio, raggio, 0, 6.283); x.fill();
    return (stampi[col] = c);
  }
  function stampoStella(){
    if (stampi.stella) return stampi.stella;
    var r = LUCI_RIF * LUCI_SCALA, meta = Math.ceil(r * 2.5), c = document.createElement('canvas');
    c.width = c.height = meta * 2;
    var x = c.getContext('2d'); x.translate(meta, meta);
    var g = x.createRadialGradient(0,0,0,0,0,r*1.6);
    g.addColorStop(0,'rgba(255,255,255,.95)'); g.addColorStop(.25,'rgba(220,255,245,.45)'); g.addColorStop(1,'rgba(255,255,255,0)');
    x.fillStyle = g; x.beginPath(); x.arc(0,0,r*1.6,0,6.283); x.fill();
    x.fillStyle = 'rgba(255,255,255,.9)';
    x.beginPath(); x.moveTo(0,-r*2.4); x.quadraticCurveTo(r*.18,0,0,r*2.4); x.quadraticCurveTo(-r*.18,0,0,-r*2.4); x.fill();
    x.beginPath(); x.moveTo(-r*2.4,0); x.quadraticCurveTo(0,r*.18,r*2.4,0); x.quadraticCurveTo(0,-r*.18,-r*2.4,0); x.fill();
    return (stampi.stella = c);
  }

  /* controller unico */
  var Luci = { tele: [], visibili: 0, id: 0, ultimo: 0, fotogrammi: 0, partito: false };
  var luciIO = window.IntersectionObserver ? new IntersectionObserver(function(voci){
    for (var i=0;i<voci.length;i++){
      var tl = voci[i].target._gsTela; if (!tl) continue;
      var ora = voci[i].isIntersecting;
      if (ora !== tl.visibile) { tl.visibile = ora; Luci.visibili += ora ? 1 : -1; }
      if (ora) { tl.misura(); if (!tl.disegnata || LUCI_FERMO) luciDisegna(tl, performance.now(), 0); }
    }
    luciGira();
  }, { rootMargin: '100px' }) : null;
  var luciRO = window.ResizeObserver ? new ResizeObserver(function(voci){
    for (var i=0;i<voci.length;i++){ var tl = voci[i].target._gsTela; if (tl && tl.misura(true)) luciDisegna(tl, performance.now(), 0); }
  }) : null;

  function luciAvvia(cv){
    if (cv._gsTela) return;
    var ctx = cv.getContext('2d'); if (!ctx) return;
    var dpr = Math.min(1.5, window.devicePixelRatio || 1);
    var CALDO = cv.getAttribute('data-gs-luci-tono') === 'caldo';
    var COLORI = CALDO ? ['rgba(255,210,140,', 'rgba(255,190,200,', 'rgba(255,240,200,'] : ['rgba(255,214,150,', 'rgba(170,240,255,', 'rgba(210,190,255,'];
    var BASE = CALDO ? 'rgba(255,236,205,' : 'rgba(235,255,250,';
    var tela = { cv: cv, ctx: ctx, W: 0, H: 0, luci: [], visibile: false, disegnata: false };
    tela.misura = function(forza){
      var W = cv.clientWidth, H = cv.clientHeight; if (!W || !H) return false;
      if (W === tela.W && H === tela.H && tela.luci.length) return false;
      tela.W = W; tela.H = H;
      var d = W*H > 300000 ? 1 : dpr;
      cv.width = Math.round(W*d); cv.height = Math.round(H*d);
      var luci = [], n = Math.max(12, Math.min(260, Math.round(W*H/5200)));
      for (var i=0;i<n;i++){
        var tipo = Math.random();
        luci.push({ x: Math.random()*W, y: Math.random()*H,
          r: tipo < .08 ? (Math.random()*2.6+2.2) : (tipo < .35 ? (Math.random()*1.4+.9) : (Math.random()*.9+.25)),
          stella: tipo < .22, fase: Math.random()*6.283, vel: Math.random()*1.6+.5,
          dx: (Math.random()-.5)*.06, dy: -(Math.random()*.05+.01), ang: Math.random()*.8,
          img: stampoBagliore(Math.random() < .12 ? COLORI[i%3] : BASE) });
      }
      tela.luci = luci; tela.disegnata = false;
      return true;
    };
    cv._gsTela = tela;
    Luci.tele.push(tela);
    if (luciIO) luciIO.observe(cv); else { tela.visibile = true; Luci.visibili++; tela.misura(); luciDisegna(tela, 0, 0); }
    if (luciRO) luciRO.observe(cv);
  }

  function luciDisegna(tela, t, passi){
    var ctx = tela.ctx, W = tela.W, H = tela.H, luci = tela.luci, stella = stampoStella();
    if (!W || !H) return;
    var dpr = tela.cv.width / W, sb = stella.width / 2, fermo = LUCI_FERMO;
    ctx.setTransform(1,0,0,1,0,0); ctx.clearRect(0,0,tela.cv.width,tela.cv.height);
    for (var i=0;i<luci.length;i++){
      var p = luci[i];
      if (passi){ p.x += p.dx*passi; p.y += p.dy*passi; if (p.y < -10){ p.y = H+10; p.x = Math.random()*W; } }
      /* da ferme ogni luce ha una sua intensita fissa, cosi il cielo non sembra piatto */
      var s = fermo ? Math.pow(Math.max(0, Math.sin(p.fase)), 3) * .8 + .15 : Math.pow(Math.max(0, Math.sin(t/1000*p.vel + p.fase)), 3);
      var o = .15 + .85*s;
      if (p.stella){
        var sc = p.r*(.6+.6*s) / (LUCI_RIF*LUCI_SCALA) * dpr, a = p.ang + t/9000, co = Math.cos(a)*sc, si = Math.sin(a)*sc;
        ctx.globalAlpha = o;
        ctx.setTransform(co, si, -si, co, p.x*dpr, p.y*dpr);
        ctx.drawImage(stella, -sb, -sb);
      } else {
        var rr = p.r*3*dpr;
        ctx.globalAlpha = o*.8;
        ctx.setTransform(1,0,0,1,0,0);
        ctx.drawImage(p.img, p.x*dpr - rr, p.y*dpr - rr, rr*2, rr*2);
      }
    }
    ctx.setTransform(1,0,0,1,0,0);
    ctx.globalAlpha = 1;
    tela.disegnata = true;
  }

  function luciFerma(perSessione){
    if (Luci.id) cancelAnimationFrame(Luci.id);
    Luci.id = 0; Luci.ultimo = 0;
    if (perSessione) {
      LUCI_FERMO = true;
      try { sessionStorage.setItem('gsLuciFerme', '1'); } catch (e) {}
    }
  }
  function luciCiclo(t){
    Luci.id = 0;
    if (LUCI_FERMO || document.hidden || !Luci.visibili) { Luci.ultimo = 0; return; }
    if (!Luci.ultimo || t - Luci.ultimo >= LUCI_PASSO) {
      var passi = Luci.ultimo ? Math.min(4, (t - Luci.ultimo) / 16.67) : 1;
      Luci.ultimo = t;
      var t0 = performance.now();
      for (var i=0;i<Luci.tele.length;i++){ if (Luci.tele[i].visibile) luciDisegna(Luci.tele[i], t, passi); }
      Luci.fotogrammi++;
      /* dopo qualche fotogramma di riscaldamento: se il disegno pesa troppo, luci ferme per la sessione */
      if (Luci.fotogrammi > LUCI_RISCALDO && performance.now() - t0 > LUCI_SOGLIA) { luciFerma(true); return; }
    }
    Luci.id = requestAnimationFrame(luciCiclo);
  }
  function luciGira(){ if (!Luci.id && Luci.partito && !LUCI_FERMO && !document.hidden && Luci.visibili) Luci.id = requestAnimationFrame(luciCiclo); }
  function luciTutte(){ var c = document.querySelectorAll('canvas[data-gs-luci]'); for (var i=0;i<c.length;i++) luciAvvia(c[i]); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', luciTutte); else luciTutte();
  document.addEventListener('shopify:section:load', luciTutte);
  document.addEventListener('visibilitychange', function(){ if (document.hidden) luciFerma(false); else luciGira(); });
  /* da desktop l animazione parte solo a pagina caricata e processore libero */
  if (!LUCI_FERMO) {
    var parti = function(){ Luci.partito = true; luciGira(); };
    var dopo = function(){ if (window.requestIdleCallback) requestIdleCallback(parti, { timeout: 3000 }); else setTimeout(parti, 1500); };
    if (document.readyState === 'complete') dopo(); else window.addEventListener('load', dopo);
  }
  /* tele e schede aggiunte dopo (scorrimento infinito, carrello, ricerca): un solo osservatore */
  if (window.MutationObserver) {
    var nuoviTimer = null;
    new MutationObserver(function(liste){
      var serve = false;
      for (var i=0;i<liste.length && !serve;i++){
        var n = liste[i].addedNodes;
        for (var k=0;k<n.length;k++){ if (n[k].nodeType === 1 && !/^(SCRIPT|LINK|STYLE|IFRAME|NOSCRIPT|META|IMG|SOURCE|TEMPLATE)$/.test(n[k].nodeName)) { serve = true; break; } }
      }
      if (!serve) return;
      clearTimeout(nuoviTimer);
      nuoviTimer = setTimeout(function(){ luciTutte(); avvia(); avviaOnda(); }, 120);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  /* ---- Una voce alla volta ---- */
  function voceAvvia(box){
    if (box._gsVoce) return; box._gsVoce = true;
    var testo = box.querySelector('[data-voce-testo]'), nome = box.querySelector('[data-voce-nome]'), av = box.querySelector('[data-voce-av]');
    var voci = box.querySelectorAll('[data-voce-i]'); if (!testo || !voci.length) return;
    var idx = 0, sec = parseInt(box.getAttribute('data-intervallo'), 10) || 0, timer = 0, fermo = false;
    function iniziali(n){ var p = (n || '').trim().split(/\s+/); return ((p[0]||'').charAt(0) + (p.length > 1 ? p[p.length-1].charAt(0) : '')).toUpperCase(); }
    function mostra(i){
      idx = i; var v = voci[i];
      testo.style.opacity = 0;
      setTimeout(function(){
        testo.textContent = v.getAttribute('data-testo'); nome.textContent = v.getAttribute('data-nome');
        av.textContent = iniziali(v.getAttribute('data-nome')); av.style.background = v.getAttribute('data-colore');
        testo.style.opacity = 1;
      }, 220);
      for (var k=0;k<voci.length;k++){ voci[k].classList.toggle('is-on', k===i); voci[k].setAttribute('aria-selected', k===i ? 'true' : 'false'); }
    }
    for (var k=0;k<voci.length;k++){ (function(i){ voci[i].addEventListener('click', function(){ mostra(i); riavvia(); }); })(k); }
    box.addEventListener('mouseenter', function(){ fermo = true; });
    box.addEventListener('mouseleave', function(){ fermo = false; });
    function riavvia(){ clearInterval(timer); if (sec > 0 && !LUCI_FERMO) timer = setInterval(function(){ if (!fermo && !document.hidden) mostra((idx+1) % voci.length); }, sec*1000); }
    riavvia();
  }
  function vociTutte(){ var b = document.querySelectorAll('[data-gs-voce]'); for (var i=0;i<b.length;i++) voceAvvia(b[i]); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', vociTutte); else vociTutte();
  document.addEventListener('shopify:section:load', vociTutte);

  /* ---- Pagamenti: calcolo delle 3 rate ---- */
  function pagAvvia(box){
    if (box._gsPag) return; box._gsPag = true;
    var bottoni = box.querySelectorAll('.gs-pag__p'); if (!bottoni.length) return;
    function migliaia(intero){ return String(intero).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
    var fmt = { format: function(n){ var c = Math.round(n*100), i = Math.floor(c/100), d = String(c % 100).padStart(2,'0'); return '€' + migliaia(i) + ',' + d; } };
    var fmt0 = { format: function(n){ var c = Math.round(n*100), i = Math.floor(c/100), d = c % 100; return '€' + migliaia(i) + (d ? ',' + String(d).padStart(2,'0') : ''); } };
    for (var i=0;i<bottoni.length;i++){
      (function(b){
        b.addEventListener('click', function(){
          for (var k=0;k<bottoni.length;k++){ bottoni[k].classList.toggle('is-on', bottoni[k]===b); bottoni[k].setAttribute('aria-selected', bottoni[k]===b ? 'true' : 'false'); }
          var cent = parseInt(b.getAttribute('data-prezzo'), 10) || 0, rata = Math.round(cent/3)/100;
          box.querySelectorAll('[data-pag-rata],[data-pag-r]').forEach(function(x){ x.textContent = fmt.format(rata); });
          var t = box.querySelector('[data-pag-tot]'); if (t) t.textContent = fmt0.format(cent/100);
          var n = box.querySelector('[data-pag-nome]'); if (n) n.textContent = b.getAttribute('data-nome');
          var l = box.querySelector('[data-pag-link]'); if (l) l.setAttribute('href', b.getAttribute('data-url') || '#');
          var im = box.querySelector('[data-pag-img]');
          if (im && b.getAttribute('data-img')) { im.style.opacity = 0; setTimeout(function(){ im.src = b.getAttribute('data-img'); im.style.opacity = 1; }, 180); }
        });
      })(bottoni[i]);
    }
  }
  function pagTutti(){ var b = document.querySelectorAll('[data-gs-pag]'); for (var i=0;i<b.length;i++) pagAvvia(b[i]); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', pagTutti); else pagTutti();
  document.addEventListener('shopify:section:load', pagTutti);

  /* ---- Nastro orizzontale di schede (Scelti per te) ---- */
  function nastroAggiorna(box){
    var n = box.querySelector('[data-gs-nastro]'), av = box.querySelector('[data-gs-avanz]');
    if (!n) return;
    var max = n.scrollWidth - n.clientWidth;
    var q = max > 0 ? n.scrollLeft / max : 0;
    if (av) {
      var larg = n.scrollWidth ? n.clientWidth / n.scrollWidth : 1;
      av.style.width = (Math.min(1, larg) * 100) + '%';
      av.style.transform = 'translateX(' + (larg < 1 ? q * (1 / larg - 1) * 100 : 0) + '%)';
    }
    n.classList.toggle('is-inizio', n.scrollLeft <= 2);
    n.classList.toggle('is-fine', n.scrollLeft >= max - 2);
    var b = box.querySelectorAll('[data-gs-scorri]');
    for (var i = 0; i < b.length; i++) {
      var dir = parseInt(b[i].getAttribute('data-gs-scorri'), 10);
      b[i].disabled = dir < 0 ? n.scrollLeft <= 2 : n.scrollLeft >= max - 2;
    }
  }
  function nastriAvvia(){
    var boxes = document.querySelectorAll('[data-gs-nastro-box]');
    for (var i = 0; i < boxes.length; i++) {
      (function(box){
        if (box._gsNastro) { nastroAggiorna(box); return; }
        box._gsNastro = true;
        var n = box.querySelector('[data-gs-nastro]'); if (!n) return;
        n.addEventListener('scroll', function(){ nastroAggiorna(box); }, { passive: true });
        window.addEventListener('resize', function(){ nastroAggiorna(box); });
        nastroAggiorna(box);
      })(boxes[i]);
    }
  }
  document.addEventListener('click', function(e){
    var b = e.target.closest && e.target.closest('[data-gs-scorri]');
    if (!b) return;
    var box = b.closest('[data-gs-nastro-box]'); if (!box) return;
    var n = box.querySelector('[data-gs-nastro]'), voce = n && n.firstElementChild;
    if (!n || !voce) return;
    var gap = parseFloat(getComputedStyle(n).columnGap) || 18;
    n.scrollBy({ left: (voce.getBoundingClientRect().width + gap) * parseInt(b.getAttribute('data-gs-scorri'), 10), behavior: 'smooth' });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', nastriAvvia); else nastriAvvia();
  window.addEventListener('load', nastriAvvia);
  document.addEventListener('shopify:section:load', nastriAvvia);

  /* ---- Pillola orari del negozio (fuso Europe/Rome) ---- */
  var GIORNI_OK=['domenica','lunedì','martedì','mercoledì','giovedì','venerdì','sabato'];
  function inMinuti(t){
    var m=/^\s*(\d{1,2})[:.](\d{2})\s*$/.exec(t||''); if(!m) return null;
    return parseInt(m[1],10)*60+parseInt(m[2],10);
  }
  function comeOra(min){
    var h=Math.floor(min/60), m=min%60;
    return h+'.'+(m<10?'0'+m:''+m);
  }
  function fasceDi(n){
    var out=[];
    ['data-mattina','data-pomeriggio'].forEach(function(k){
      var v=(n.getAttribute(k)||'').split('-');
      if(v.length===2){ var a=inMinuti(v[0]), b=inMinuti(v[1]); if(a!==null&&b!==null&&b>a) out.push([a,b]); }
    });
    out.sort(function(x,y){return x[0]-y[0];});
    return out;
  }
  function orariNegozio(){
    var nodi=document.querySelectorAll('[data-gs-orari]');
    for(var i=0;i<nodi.length;i++){
      var n=nodi[i], testo=n.querySelector('b'); if(!testo) continue;
      var fasce=fasceDi(n); if(!fasce.length) continue;
      var chiusi=(n.getAttribute('data-chiusi')||'').split(',').map(function(x){return parseInt(x,10);}).filter(function(x){return x>=0&&x<=6;});
      var d;
      try{ d=new Date(new Date().toLocaleString('en-US',{timeZone:'Europe/Rome'})); }catch(e){ d=new Date(); }
      if(isNaN(d.getTime())) d=new Date();
      var giorno=d.getDay(), adesso=d.getHours()*60+d.getMinutes();
      var chiusoOggi=chiusi.indexOf(giorno)>-1, frase=null, aperto=false;
      if(!chiusoOggi){
        for(var f=0;f<fasce.length;f++){
          if(adesso>=fasce[f][0] && adesso<fasce[f][1]){ aperto=true; frase='Aperto ora fino alle '+comeOra(fasce[f][1]); break; }
        }
        if(!aperto){
          for(var g=0;g<fasce.length;g++){
            if(adesso<fasce[g][0]){ frase=(g===0?'Apre oggi alle ':'Riapre oggi alle ')+comeOra(fasce[g][0]); break; }
          }
        }
      }
      if(!frase){
        for(var k=1;k<=7;k++){
          var pross=(giorno+k)%7;
          if(chiusi.indexOf(pross)===-1){
            var quando=(k===1)?'domani':GIORNI_OK[pross];
            frase='Chiuso ora, apre '+quando+' alle '+comeOra(fasce[0][0]);
            break;
          }
        }
      }
      if(frase){ testo.textContent=frase; n.classList.toggle('is-chiuso', !aperto); }
    }
  }
  orariNegozio();
  setInterval(orariNegozio, 60000);
  document.addEventListener('shopify:section:load', orariNegozio);

  /* ---- Orari nel piede di pagina ---- */
  function orariPiede(){
    var nodi = document.querySelectorAll('[data-gsf-stato]');
    for (var i=0;i<nodi.length;i++){
      var n = nodi[i];
      var fasce = fasceDi(n); if(!fasce.length) continue;
      var chiusi = (n.getAttribute('data-chiusi')||'').split(',').map(function(x){return parseInt(x,10);}).filter(function(x){return x>=0&&x<=6;});
      var d;
      try{ d=new Date(new Date().toLocaleString('en-US',{timeZone:'Europe/Rome'})); }catch(e){ d=new Date(); }
      if(isNaN(d.getTime())) d=new Date();
      var giorno=d.getDay(), adesso=d.getHours()*60+d.getMinutes();
      var aperto=false, breve='', coda='';
      if (chiusi.indexOf(giorno)===-1){
        for (var f=0;f<fasce.length;f++){
          if (adesso>=fasce[f][0] && adesso<fasce[f][1]){ aperto=true; breve='Aperto ora'; coda='fino alle '+comeOra(fasce[f][1]); break; }
        }
        if(!aperto) for (var g=0;g<fasce.length;g++){
          if (adesso<fasce[g][0]){ breve='Chiuso ora'; coda=(g===0?'apre alle ':'riapre alle ')+comeOra(fasce[g][0]); break; }
        }
      }
      if(!breve){
        for (var k=1;k<=7;k++){
          var pross=(giorno+k)%7;
          if (chiusi.indexOf(pross)===-1){ breve='Chiuso ora'; coda='apre '+(k===1?'domani':GIORNI_OK[pross])+' alle '+comeOra(fasce[0][0]); break; }
        }
      }
      var t=n.querySelector('[data-gsf-testo]'); if(t) t.textContent=breve;
      n.classList.toggle('is-chiuso', !aperto);
      var root=n.closest('.gsf') || document;
      var fino=root.querySelector('[data-gsf-fino]'); if(fino) fino.textContent=coda;
      var pill=root.querySelector('[data-gsf-pill]');
      if(pill){
        var pt=pill.querySelector('[data-gsf-pilltesto]'); if(pt) pt.textContent=breve+', '+coda;
        pill.classList.toggle('is-chiuso', !aperto);
      }
    }
  }
  orariPiede();
  setInterval(orariPiede, 60000);
  document.addEventListener('shopify:section:load', orariPiede);


})();
